<template>
  <div>
    <Header :home="false" :logged="logged" :arealogada="true" />


    <!-- Downloads -->
    <a id="downloadip" download="downloadip" style="display: none" />
    <a id="downloadIrregularidade" download="downloadIrregularidade" style="display: none" />
    <a id="dwnldLnk" download="pdf_pedido" style="display: none" />
    <a id="protesto_anexo" download="anexo_pedido" style="display: none" />
    <a id="protesto_recibo" download=" Recibo_Pedido_de_Protesto" style="display: none" />
    <a style="display:block" id="download_boleto" download="download_boleto" />

    <b-modal ref="modalInstabilidade" @ok="respostaModalInstabilidade" title="Atenção" :hide-header-close="true" :no-close-on-esc="true"
      :no-close-on-backdrop="true">
      <p>
        Prezados,
      </p>
      <p>
        Os serviços que incidem em pagamento de emolumentos encontram-se bloqueados para manutenção do sistema e ajuste de valores. Retornaremos em breve.
      </p>
      <p>
        Qualquer dúvida, estamos à disposição!
      </p>
    </b-modal>

    <b-modal ref="modalAcaoAnexo" ok-only title="Pedidos Aguardando Anexo" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <p>
        Existem pedidos que necessitam de sua atenção!
      </p>
      <p>
        Sua ação é necessaria para Pedidos com solicitações de documentos pendentes de envio. Caso não seja enviado anexo, os pedidos não terão prosseguimento.
      </p>
    </b-modal>

    <ModalUploadDocumentos
        modal-id="upload-modal"
        title="Upload de Documentos"
        :accepted-types="'.pdf, .xls, .xlsx, .p7s, .zip'"
        :max-file-size="5300000"
        :max-files="1"
        :allow-multiple="false"
        @files-selected="handleFilesSelected"
    />

    <b-modal ref="modalBoleto" :size="sizemodalboleto" scrollable title="Boleto" id="modalboleto">
      <div v-if="pdf_boleto">
        <div v-if="sizemodalboleto == 'lg'">
          <div class="col-12 text-center">
            <img src="~@/assets/imgs/logo.svg" class="w-50" />
            <br><br><br><br>
            <h4><b>Valor R$: {{ boletoSelecionado.vl_custa || Moeda }}</b></h4>
            <br /><br />
          </div>
          <div class="offset-4 col-8 text-center qrcodePix">
            <b-embed type="iframe" aspect="1by1" :src="pdf_boleto" allowfullscreen v-if="pdf_boleto"></b-embed>
          </div>
          <div class="col-12 text-center">
            <h4><b>Faça a leitura do QR CODE e aguarde.</b></h4>
            <h4><b>Ou</b></h4>
            <b-card>
              <h5><b>LINK DE PAGAMENTO (PIX COPIA E COLA)</b></h5>
              <textarea class="textarea" ref="copiar" v-model="linkPIX" cols="80" rows="4">
                </textarea>
              <b-button variant="primary" @click="copiarLink()">
                <font-awesome-icon icon="copy" /> &nbsp;&nbsp;&nbsp;&nbsp; Copiar link de pagamento
              </b-button>
            </b-card>
            <h4><b><br><br>Consulta de pagamento em {{ secondcd }} segundos.</b></h4>
          </div>
        </div>
        <div v-else>
          <b-embed type="iframe" aspect="1by1" :src="pdf_boleto" allowfullscreen v-if="pdf"></b-embed>
        </div>
      </div>
      <p v-else class="mensagemErro bold">{{ mensagemBolErro }}</p>
    </b-modal>
    <b-modal id="msgErroExcel" ref="msgErroExcel" size="lg" title="Aviso!" ok-only>
      <p>
        Não foi possível realizar o download do arquivo Excel com a relação dos
        pedidos solicitados.
      </p>
      <p>
        Tente desativar temporiariamente seu anti-vírus e acione a exportação
        novamente.
      </p>
    </b-modal>
    <b-modal size="xl" ref="anexoNotaDevolutiva" title="Upload Nota Devolutiva">
      <p class="my-4">
        <template>
          <ul class="list-group">
            <li class="list-group-item">
              <b-row>
                <b-col cols="2">
                  <b>Nr. Pedido:</b>
                  {{ cd_pedido_protesto_v }}
                </b-col>
                <b-col cols="8">
                  <b-form-file accept=".pdf" label="Anexo" v-model="NotaDevolutivaPDF"
                    @change="atualizaArquivo"></b-form-file>
                </b-col>
                <b-col cols="2">
                  <b-button variant="success" class="float-right"
                    @click="confirmarNotaDevolutiva(cd_pedido_protesto_v)">
                    Confirmar
                  </b-button>
                </b-col>
              </b-row>
              <b-row v-if="loadingNota">
                <b-col cols="12" class="text-center">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="12" class="mt-4">
                  <b>Arquivo anexo: </b>
                  <a :download="cd_pedido_protesto_v + '.pdf'" :id="cd_pedido_protesto_v" :href="'data:application/pdf;base64,' + ds_nota_devolutiva_b64
      ">{{ "nota_devolutiva_" + cd_pedido_protesto_v + ".pdf" }}</a>
                  <!-- <font-awesome-icon
                    class="ml-4"
                    icon="trash"
                    color="red"
                    size="1x"
                    title="Excluir arquivo"
                    style="cursor: pointer"
                  /> -->
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-alert class="mt-2" dismissible fade> </b-alert>
                </b-col>
              </b-row>
            </li>
          </ul>
        </template>
      </p>
    </b-modal>

    <Modal
      mensagem="Caso o pagamento não seja realizado na data de vencimento, o pedido será automaticamente cancelado."
      @resposta="respConfirm" />
    <b-modal ref="detalhesModal" title="Detalhes da Irregularidade" size="xl">
      <b-table :fields="camposDetIrregularidade.fields" :items="detalhesData" striped>
        <template v-slot:cell(dt_protocolo)="data">
          {{ data.value | data }}
        </template>
      </b-table>
      <b-button
        @click="downloadArquivo(detalhesData[0].nm_aws_chave_arquivo, detalhesData[0].nm_aws_bucket, detalhesData[0].cd_pedido_protesto)"
        variant="primary" v-if="detalhesData[0] != undefined && detalhesData[0].hasFile >= 1">
        <font-awesome-icon size="1x" icon="download" />
        &nbsp;
        Download
      </b-button>
    </b-modal>
    <b-modal ref="modalPagamento" id="modalPagamento" :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg">
      <template v-slot:modal-header="{ close }">
        <h5>Selecione a forma de pagamento</h5>
      </template>
      <template v-slot:default="{ hide }">
        <b-form-select id="input-4" v-model="formaPagamento" :options="formasPagamento"
          @change="alteraFPG"></b-form-select>
        <div v-if="formaPagamento.toString().includes('credit') == true" class="mt-4">
          <b-card bg-variant="light" title="Dados do cartão">
            <parcela-checkout :environment=ENVIRONMENT_EXPRESS :clientKey=CLIENT_KEY_EXPRESS :apiUrl=URL_EXPRESS
              :sellerKey=SELLER_KEY_EXPRESS successReturnUrl="https://success-url.com.br"
              errorReturnUrl="https://error-url.com.br" />
          </b-card>
        </div>
        <p class="mt-3">Caso o pagamento não seja realizado na data de vencimento, o pedido será automaticamente
          cancelado.</p>
        <br>
        <p>A opção de pagamento de certidão/cancelamento, seja por meio de PIX, cartão de crédito ou boleto não altera o
          prazo de entrega/efetivação, pois a transferência ao devido tabelionato, ocorre 1 dia após ao efetivo
          pagamento.
        </p>
        <br>
        <p><b style="color: red;">*Após realizado o pagamento, os pedidos não poderão mais ser cancelados</b></p>
        <br>
        <p>O processamento dos pagamentos são realizados pela Parcela Express Servicos Digitais.</p>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="lg" variant="danger" class="mr-auto" @click="respConfirm('n')">Cancelar</b-button>
        <b-button size="lg" variant="success" @click="respConfirm('s')"
          v-if="formaPagamento.toString().includes('credit') !== true">Aceitar</b-button>
      </template>
    </b-modal>
    <b-modal ref="ModalPagamentoCartao" title="Pagamento Recusado">
      <p>Pagamento recusado! Verifique os dados do cartão e tente novamente.</p>
    </b-modal>

    <!-- Modal de Pagamento Retirada (CC e PIX realtime) -->
    <ModalPagamentoRealtime
      ref="modalPagamentoRetirada"
      modal-id="retirada"
      :value="valorRetirada"
      :formas-pagamento="formasPagamentoRetirada"
      @pagamento-realizado="onPagamentoRetiradaRealizado"
    />

    <!-- Tutorial guiado: início do fluxo de Retirada (botão + → Pagamento Retirada) -->
    <TutorialGuiado
      ref="tutorial"
      nm-tutorial="pedido_retirada"
      @ativo="tutorialAtivo = $event"
      @concluido="pesquisar"
    />

    <div class="text-center" v-if="loading" style="
        background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: 10002;
        margin: 0;
        top: 0;
        padding-top: 20%;
      ">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Text Centered"></b-spinner>
      <br /><span style="color: #004e86">Processando Aguarde...</span>
    </div>
    <b-modal ref="modalConfirmaDados" size="xl" scrollable title="Dados do Pedido de Protesto">
      <div>
        <b-col cols="11" class="ml-5">
          <b-card>
            <template v-slot:header>
              <h4 class="mb-0">Dados do Cartório</h4>
            </template>
            <div>
              <b-row>
                <b-col cols="6" class="mt-1">
                  <font size="4"><b>Nome: </b>{{ dadosCartorio.nome }}</font>
                </b-col>
                <b-col cols="6" class="mt-1">
                  <font size="4"><b>CNPJ: </b> {{ dadosCartorio.cnpj }}</font>
                </b-col>
                <b-col cols="6" class="mt-1">
                  <font size="4"><b>E-mail: </b> {{ dadosCartorio.email }}</font>
                </b-col>
                <b-col cols="6" class="mt-1">
                  <font size="4"><b>Telefone: </b> {{ dadosCartorio.telefone }}</font>
                </b-col>
                <b-col cols="6" class="mt-1">
                  <font size="4"><b>UF: </b> {{ dadosCartorio.uf }}</font>
                </b-col>
                <b-col cols="6" class="mt-1">
                  <font size="4"><b>Cidade: </b> {{ dadosCartorio.cidade }}</font>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
        <b-col cols="11" class="ml-5" v-if="dadosCartorio.cd_pedido_cartorio_liquidacao &&
      (dadosCartorio.cd_ted_status == '2' ||
        dadosCartorio.ds_comprovante_ted_pdf_b64 != NULL)
      ">
          <b-card class="mt-2">
            <template v-slot:header>
              <h4 class="mb-0">Comprovante TED</h4>
            </template>
            <div>
              <b-row>
                <b-col cols="12" class="mt-1">
                  <font size="4">
                    <b @click="
      downloadComprovante(
        dadosCartorio.cd_pedido_cartorio_liquidacao
      )
      ">Download Comprovante</b>
                    &nbsp;
                    <font-awesome-icon icon="download" size="1x" @click="
      downloadComprovante(
        dadosCartorio.cd_pedido_cartorio_liquidacao
      )
      " style="cursor: pointer" title="Download do comprovante" />
                  </font>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </div>
      <pdfx v-for="i in numPages" :key="i" :src="pdfConfirma" :page="i"
        style="width: 100%; height: 1430px; display: inline-block" class="mr-4"></pdfx>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button v-if="libCanc" variant="danger" class="float-right" @click="cancelarSolicitacao">
            Cancelar Solicitação
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal ref="confirmaCancelamento" size="xl" scrollable title="Cancelar pedido de protesto?">
      Deseja cancelar a solicitação de protesto? Essa ação é irreversivel.
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="success" class="float-right" @click="confirmarCancelamento">
            Confirmar cancelamento
          </b-button>
          <b-button variant="danger" class="float-left" @click="cancelarOperacao">
            Cancelar operação
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal ref="modalConfirmar" size="xl" scrollable title="Cancelar pedido de protesto?">
      Deseja cancelar a solicitação de protesto? Essa ação é irreversível
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="success" class="float-right" @click="pedidoCancelar">
            Confirmar Cancelamento
          </b-button>
          <b-button variant="danger" class="float-left" @click="cancelarOperacaoProtesto">
            Cancelar operação
          </b-button>
        </div>
      </template>
    </b-modal>


    <b-modal ref="erro" title="Atenção">
      <p>{{ this.erro }}</p>
    </b-modal>
    <b-modal ref="modalLoading" size="xl" title="Carregando" :no-close-on-backdrop="true" :no-close-on-esc="true"
      :hide-footer="true">
      <p class="my-4">
        <template>
          <div class="d-flex justify-content-center mb-3">
            <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Large Spinner"></b-spinner>
          </div>
        </template>
      </p>
    </b-modal>

    <b-modal ref="modalConfirmaCancelamento" title="Cancelar protesto">
      <p>O pedido nº {{ this.cd_pedido_protesto_v }} foi cancelado com sucesso</p>
    </b-modal>
    <b-modal ref="modalExpira" title="Cancelar protesto">
      <p>Não foi possível cancelar o pedido de protesto, pois o limite de 5 minutos após o cadastro expirou</p>
    </b-modal>

    <b-modal ref="cotacaoSP" title="Cotação SP" :no-close-on-backdrop="true" :no-close-on-esc="false"
      :hide-footer="false" :ok-only="true" @hide="limparCotacaoSP">
      <p style="white-space: pre-line">{{ msgCotacaoSP }}</p>
    </b-modal>
    <b-modal ref="instrumentoSP" title="Instrumento de Protesto - SP" :no-close-on-backdrop="true"
      :no-close-on-esc="false" :hide-footer="false" :ok-only="true" @hide="limparInstrumentoSP">
      <p style="white-space: pre-line">{{ msgInstrumentoSP }}</p>
    </b-modal>
    <div id="painel" class="container-fluid">
      <b-row>
        <b-col cols="12" md="4" lg="3" style="padding: 0;" class="espaco-menu d-none d-xl-block">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex painel-content">
          <b-alert variant="warning" show>Pesquisas sem filtro irão retornar as 50 ultimas solicitações</b-alert>
          <b-alert variant="danger" :show="hasAguardandoAnexo">Você possui pedidos que necessitam de sua atenção. <b>Aguardando anexo de arquivo para prosseguir.</b></b-alert>

          <b-container fluid id="painelcontainerfluid">
            <b-row>
              <b-col cols="10" style="padding: 0;">
                <b-breadcrumb :items="breadCrumb"></b-breadcrumb>
              </b-col>
              <b-col cols="2" style="padding: 0.75rem 1rem;">
                <b-link class="btn-voltar" href="/painel"
                  style="text-decoration:none;font: normal normal bold 16px/24px 'Kanit', sans-serif;color:#597EB5;">
                  Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                </b-link>
              </b-col>
            </b-row>
            <!-- <h4 class="text-primary mt-5"><b>Solicitações de protesto</b></h4> -->
            <arealogadapesquisa id="tabela-todos-pedidos" :resultado="itemFiltrado" :colunas="colunas" :colunasMobile="colunasMobile"
              :hasFilter="true" :page="'VisualizarPedidoProtesto'" :title="'Solicitações de protesto'"
              @filtrarBusca="filtrarBusca" @exportarBusca="exportarBusca" @chamar-funcao="executarFuncao" />
            <!-- 
              <div>
                <div id="empresaCredoraCollapse" class="mt-2">
            -->
            <!--b-card -->
            <!--
                    <p class="card-text">Preencha um dos campos para buscar em sua lista.</p>
                  -->
            <!-- formulario de pesquisar -->
            <!--
                      <div>
                      <b-form name="frmBuscarAnuencia" id="frmBuscarAnuencia">
                        <b-row>
                          <b-col cols="12" md="6" lg="5">
                            <b-form-group
                              label="Nome do Devedor"
                              label-for="nomeDevedor"
                            >
                              <b-form-input
                                data-name="Nome do devedor"
                                data-model="form.nm_devedor"
                                id="nomeDevedor"
                                v-model="form.nm_devedor"
                                placeholder="Nome do Devedor"
                                @blur="exibePesquisa()"
                              ></b-form-input>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" md="6" lg="2">
                            <b-form-group
                              label="Número do pedido"
                              label-for="numeroPedido"
                            >
                              <b-form-input
                                data-name="Número do pedido"
                                data-model="form.cd_pedido_protesto"
                                id="numeroPedido"
                                v-model="form.cd_pedido_protesto"
                                number
                                placeholder="Número do Pedido"
                                @blur="exibePesquisa()"
                              ></b-form-input>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" md="6" lg="3">
                            <b-form-group
                              label="Documento do devedor"
                              label-for="docDevedor"
                            >
                              <the-mask
                                data-name="Documento do devedor"
                                data-model="form.nm_nr_identificacao_devedor"
                                :mask="['###.###.###-##', '##.###.###/####-##']"
                                id="docDevedor"
                                v-model="form.nm_nr_identificacao_devedor"
                                class="form-control"
                                placeholder="CPF ou CNPJ"
                                maxlength="18"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" md="6" lg="2">
                            <b-form-group label="Ocorrência" size="sm">
                              <b-form-select
                                id="cd_ocorrencia"
                                v-model="form.ocorrencia"
                                :options="listaOcorrencias"
                              ></b-form-select>
                            </b-form-group>
              -->
            <!-- 
                            <b-form-group
                              label="Status da solicitação:"
                              size="sm"
                            >
                              <b-form-select
                                id="cd_status"
                                @change="selectStatus($event)"
                                v-model="form.cd_pedido_p_status"
                                :options="statusSolicitacao"
                              ></b-form-select>
                            </b-form-group> 
                            -->
            <!--
                          </b-col>

                          <b-col cols="12" md="6" lg="3">
                            <b-form-group
                              label="Número do título"
                              label-for="nrtituloDevedor"
                            >
                              <b-form-input
                                data-name="Número do título"
                                data-model="form.nm_nr_titulo"
                                id="nrtituloDevedor"
                                v-model="form.nm_nr_titulo"
                                placeholder="Numero"
                                @blur="exibePesquisa()"
                              ></b-form-input>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" md="4" lg="3">
                            <b-form-group
                              id="dtVencimento"
                              label="Data do Vencimento"
                              label-for="dtVencimento"
                            >
                              <b-form-input
                                id="dtVencimento"
                                v-model="form.dt_vencimento"
                                type="date"
                                @blur="exibePesquisa()"
                                required
                              ></b-form-input>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" md="6" lg="3">
                            <b-form-group
                              label="Valor Título"
                              label-for="valorProtestado"
                            >
                              <b-form-input
                                id="valorProtestado"
                                v-model.number="form.vl_titulo"
                                placeholder="R$ 0,00"
                                @keyup="moeda"
                                @blur="exibePesquisa()"
                                maxlength="21"
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12" md="6" lg="3">
                            <b-form-group
                              id="input-group-2"
                              label="Nosso Número"
                              label-for="input-2"
                            >
                              <b-form-input
                                id="nm"
                                v-model="form.nm_nosso_numero"
                                maxlength="18"
                                @blur="exibePesquisa()"
                                placeholder="Nosso Número"
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>

                          <b-row>
                        <b-col cols="12" md="9" lg="9">
                            
                        </b-col>
                        <b-col cols="12" md="2" lg="2">
                          <b-button
                            @click="pesquisar"
                            id="pesquisar"
                            type="button"
                            variant="outline-primary"
                            class="pull-right"
                            ><font-awesome-icon icon="filter" style="margin-right: -16px;" /><font-awesome-icon icon="ban" style="color: #48658f;" /> Limpar filtro</b-button
                          >
                        </b-col>
                        <b-col cols="12" md="1" lg="1">
                          <b-button
                            @click="pesquisar"
                            id="pesquisar"
                            type="button"
                            variant="primary"
                            class="pull-right"
                            ><font-awesome-icon icon="search" /> Buscar</b-button
                          >
                        </b-col>
                      </b-row>
                      <hr>
                      <b-row>
                        <b-col cols="12" md="9" lg="2">        
                          <h4 class="text-primary">Resultado da busca</h4>                
                        </b-col>
                        <b-col cols="12" md="2" lg="8">
                          <p style="color: rgb(149, 144, 144);">Filtros: 
                          <ul style="margin: 0;margin-top: -27px;cursor:pointer;">
                            <li  v-for="(item , index) in resultadoBusca" :key="index" @click="limparInput(item)" class="exibirResultado">
                              <span> <span style="background: #597eb5;border-radius: 5px;color: #fff;font-size: 10px;padding-left: 4px;padding-right: 4px;">X</span> {{item}}</span>
                            </li>
                          </ul>
                        </p>
                          
                        </b-col>
                        <b-col cols="12" md="2" lg="2">
                        <b-button
                          id="exportar"
                          type="button"
                          variant="success"
                          @click="exportar"
                          class="pull-right"
                        >
                          <font-awesome-icon icon="file-excel" /> Exportar planilha
                        </b-button>
                      </b-col>
                      </b-row>
                    </b-form>
                  </div>-->
            <!-- /b-card --><!--
              </div>
            </div>
            <br />
            <div class="alert alert-danger" role="alert" v-if="validaCampos">
              Selecione ao menos um item para a pesquisa!
            </div>
            <div
              class="alert alert-danger"
              role="alert"
              v-if="validaEmpresaSelecionada"
            >
              Selecione a empresa credora para realizar a pesquisa!
            </div>
            <div>
              <b-table
                id="my-table"
                small
                :items="items"
                :per-page="perPage"
                :current-page="currentPage"
                :fields="fields"
                stacked="sm"
                striped
                hover
                responsive="sm"
              >-->
            <!-- formata o documento --><!--
                <template #cell(cd_pedido_protesto)="row">
                  <a style="display:block" :id="'download_boleto_'+ row.item.cd_pedido_protesto" :download="'download_boleto_'+ row.item.cd_pedido_protesto" />
                  {{ row.item.cd_pedido_protesto }}
                </template>
                <template #cell(nm_nr_titulo)="row">
                  {{ row.item.nm_nr_titulo }}
                </template>
                <template #cell(nm_devedor)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.nm_devedor | upper }}
                    <span> {{ row.item.nm_devedor }} </span>
                  </a>
                </template>
                <template #cell(nm_nr_identificacao_devedor)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{
                      row.item.nm_nr_identificacao_devedor | documento | upper
                    }}
                    <span>
                      {{ row.item.nm_nr_identificacao_devedor | documento }}
                    </span>
                  </a>
                </template>
                <template #cell(dt_cadastro)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.dt_cadastro | dataHora | upper }}
                    <span> {{ row.item.dt_cadastro | dataHora }} </span>
                  </a>
                </template>
                <template #cell(vl_titulo)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.vl_titulo | moeda | upper }}
                    <span>{{ row.item.vl_titulo | moeda }}</span>
                  </a>
                </template>
                <template #cell(vl_custa)="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.vl_custa | moeda | upper }}
                    <span>{{ row.item.vl_titulo | moeda }}</span>
                  </a>
                </template>
                <template #cell()="row">
                  <a href="javascript:void(null)" class="infoT fontP">
                    {{ row.item.status_pedido | upper("4") }}
                    <span> {{ row.item.status_pedido }} </span>
                  </a>
                </template>

                <template #cell(ds_ocorrencia_titulo)="row">
                  <a
                    href="javascript:void(null)"
                    class="infoT fontP"
                    v-if="row.item.ds_ocorrencia_titulo_c != null"
                  >
                    {{ row.item.ds_ocorrencia_titulo_c | upper("10") }}
                    <span>
                      {{ row.item.ds_ocorrencia_titulo_c }} <br /><br />
                      {{ row.item.ds_motivo_irregularidade_c }}</span
                    >
                  </a>
                  <a href="javascript:void(null)" class="infoT fontP" v-else>
                    {{ row.item.ds_ocorrencia_titulo | upper("10") }}
                    <span>
                      {{ row.item.ds_ocorrencia_titulo }} <br /><br />
                      {{ row.item.ds_motivo_irregularidade }}</span
                    >
                  </a>
                </template>
                <template #cell(nr_protocolo)="row">
                  <a
                    href="javascript:void(null)"
                    class="infoT fontP"
                    v-if="row.item.nr_protocolo != null"
                  >
                    {{ row.item.nr_protocolo | upper("10") }}
                    <span>
                      {{ row.item.nr_protocolo }} <br /><br />
                      {{ row.item.dt_protocolo | dataHora }}</span
                    >
                  </a>
                </template>

                <template #cell(actions)="row">
                  <div
                    v-b-popover.hover.top="row.item.motivo_recusa"
                    title=" Motivo Recusa "
                    v-if="
                      row.item.cd_status === 'Reprovado' ||
                      row.item.cd_status === 'Finalizado'
                    "
                    class="text-center"
                  >
                    <span>
                      <font-awesome-icon
                        icon="info"
                        mask="circle"
                        size="1x"
                        color="red"
                      />
                    </span>
                  </div>
                  <a
                    :id="'protesto_anexo_' + row.item.cd_pedido_protesto"
                    :download="
                      row.item.nm_nr_titulo +
                      '_' +
                      row.item.nm_nr_identificacao_devedor +
                      '_001'
                    "
                    style="display: none"
                  />
                  <a
                    :id="'protesto_nota_devolutiva' + row.item.cd_pedido_protesto"
                    :download="'nota_devolutiva_' +   row.item.cd_pedido_protesto "
                    style="display: none"
                  />
                  <a
                    :id="'dwnldLnk' + row.item.cd_pedido_protesto"
                    :download="
                      row.item.nm_nr_titulo +
                      '_' +
                      row.item.nm_nr_identificacao_devedor +
                      '_002'
                    "
                    style="display: none"
                  />
                  <a
                    :id="'protesto_recibo_' + row.item.cd_pedido_protesto"
                    :download="
                      'Recibo_Pedido_de_Protesto_' + row.item.cd_pedido_protesto
                    "
                    style="display: none"
                  />
                  <font-awesome-icon
                    v-if="row.item.cd_pedido_cartorio"
                    icon="money-bill-wave"
                    size="1x"
                    @click="baixarRecibo(row.item.cd_pedido_protesto)"
                    style="cursor: pointer"
                    title="Recibo"
                  />
                  &nbsp;&nbsp;
                  <font-awesome-icon
                   v-if="
                      row.item.status.cd_pedido_p_status == 5 ||
                      (row.item.ds_ocorrencia_titulo_c != null &&
                        row.item.ds_ocorrencia_titulo_c.substring(0, 1) ==
                          '5') ||
                      (row.item.ds_ocorrencia_titulo != null &&
                        row.item.ds_ocorrencia_titulo.substring(0, 1) == '5')
                    "
                    icon="file-pdf"
                    size="1x"
                    @click="baixarNota(row.item.cd_pedido_protesto)"
                    style="cursor: pointer"
                    title="Download Nota Devolutiva"
                  />
                  &nbsp;&nbsp;-->
            <!-- <font-awesome-icon
                    icon="upload"
                    size="1x"
                    @click="
                      anexoNotaDevolutiva(
                        row.item.cd_pedido_protesto,
                        row.item.ds_nota_devolutiva_b64
                      )
                    "
                    v-if="
                      row.item.status.cd_pedido_p_status == 5 ||
                      (row.item.ds_ocorrencia_titulo_c != null &&
                        row.item.ds_ocorrencia_titulo_c.substring(0, 1) ==
                          '5') ||
                      (row.item.ds_ocorrencia_titulo != null &&
                        row.item.ds_ocorrencia_titulo.substring(0, 1) == '5')
                    "
                    style="cursor: pointer"
                    title="Upload do PDF da nota devolutiva"
                  /> 
                  &nbsp;&nbsp;
                  --><!--
                  <font-awesome-icon
                    icon="download"
                    size="1x"
                    @click="baixarPDF(row.item.cd_pedido_protesto)"
                    style="cursor: pointer"
                    title="Download do PDF e arquivo anexo (caso anexado)"
                  />
                  &nbsp;&nbsp;
                  <font-awesome-icon
                    icon="eye"
                    size="1x"
                    @click="visualizarPDF(row.item)"
                    style="cursor: pointer"
                    title="Visualizar dados do pedido"
                  />
                  &nbsp;&nbsp;
                  <font-awesome-icon
                    icon="barcode"
                    v-if="
                      (row.item.cd_pedido_cartorio == null ||
                        row.item.cd_pedido_c_status == 6) &&
                      row.item.cd_pedido_p_status == 12 &&
                      row.item.vl_custa > 0.01
                    "
                    size="1x"
                    @click="confirmaBoleto(row.item)"
                    style="cursor: pointer"
                    title="Gerar boleto"
                  />
                  <font-awesome-icon
                    icon="barcode"
                    v-if="
                      row.item.cd_pedido_cartorio != null &&
                      row.item.cd_pedido_c_status != 6 &&
                      row.item.cd_pedido_p_status == 4 &&
                      row.item.vl_custa > 0.01
                    "
                    size="1x"
                    @click="visualizarBoleto(row.item)"
                    style="cursor: pointer"
                    title="Visualizar boleto"
                    color="green"
                  />
                  <a
                    id="downloadip"
                    :download="'downloadip_' + row.item.cd_chave_unica"
                    style="display: none"
                  />
                  <font-awesome-icon
                    icon="file-pdf"
                    v-if="
                      row.item.cd_chave_unica != null &&
                      ((row.item.ds_ocorrencia_titulo_c != null &&
                        row.item.ds_ocorrencia_titulo_c.substring(0, 1) ==
                          '2') ||
                        (row.item.ds_ocorrencia_titulo_c != null &&
                          row.item.ds_ocorrencia_titulo_c.substring(0, 1) ==
                            '2')) &&
                      row.item.sg_uf_devedor !== 'SP'
                    "
                    size="1x"
                    @click="downloadIP(row.item.cd_chave_unica)"
                    style="cursor: pointer"
                    title="Baixar Instrumento de Protesto"
                  />
                  <font-awesome-icon
                    icon="file-pdf"
                    v-if="
                      ((row.item.ds_ocorrencia_titulo_c != null &&
                        row.item.ds_ocorrencia_titulo_c.substring(0, 1) ==
                          '2') ||
                        (row.item.ds_ocorrencia_titulo != null &&
                          row.item.ds_ocorrencia_titulo.substring(0, 1) ==
                            '2')) &&
                      row.item.sg_uf_devedor === 'SP'
                    "
                    size="1x"
                    @click="downloadIPSP(row.item.cd_pedido_protesto)"
                    style="cursor: pointer"
                    title="Baixar Instrumento de Protesto - SP"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    icon="sync"
                    size="1x"
                    style="cursor: pointer"
                    title="Realizar cotação com SP"
                    v-if="
                      row.item.sg_uf_devedor === 'SP' &&
                      row.item.cd_pedido_p_status == 3
                    "
                    @click="cotacaoSP(row.item.cd_pedido_protesto)"
                  />
                  <br />
                  <span
                    v-b-popover.hover.top="row.item.motivo_recusa"
                    title=" Motivo Recusa "
                    v-if="row.item.cd_pedido_p_status == 5"
                    class="text-center"
                  >
                    <font-awesome-icon
                      icon="info"
                      mask="circle"
                      size="1x"
                      color="red"
                    />
                  </span>
                </template>
              </b-table>
              <p>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="my-table"
                ></b-pagination>
              </p>
            </div> -->
            <div class="loading">
              <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Large Spinner"
                v-if="loading"></b-spinner>
            </div>
          </b-container>
        </b-col>
      </b-row>
    </div>
    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none" />
  </div>
</template>

<script>
// import axios from "axios"
import Header from "../../components/Header";
import API from "../../services/api";
import Menu from "../../template/Menu";
import { TheMask } from "vue-the-mask";
import pdfx from "vue-pdf";
import Modal from "../../components/modal/Confmodal";
import axios from "axios"
import '@parcelaexpress/checkout-component-js';
import arealogada from "@/components/arealogada/index.vue";
import arealogadapesquisa from "@/components/arealogada/pesquisa/index.vue";
import footersite from "@/components/footersite";
import footersitemobile from "@/components/footersite/index_mobile";
import ModalUploadDocumentos from "@/components/documentos/modal_upload_documentos/ModalUploadDocumentos.vue";
import ModalPagamentoRealtime from "@/components/modal/ModalPagamentoRealtime.vue";
import TutorialGuiado from "@/components/modal/TutorialGuiado.vue";
import Swal from 'sweetalert2';



export default {
  components: {
    ModalUploadDocumentos,
    ModalPagamentoRealtime,
    TutorialGuiado,
    Header,
    Menu,
    TheMask,
    pdfx,
    Modal,
    arealogada,
    arealogadapesquisa,
    footersite,
    footersitemobile
  },
  data() {
    return {
      breadCrumb: [
        { text: 'Painel', href: "/painel" },
        { text: 'Protesto', disabled: true },
        { text: 'Todos os Pedidos', active: true }
      ],
      detalhesData: [],
      camposDetIrregularidade: {
        fields: [
          { key: 'nm_chave', label: 'Chave' },
          { key: 'nm_cd_apresentante', label: 'Apresentante' },
          { key: 'nr_protocolo', label: 'Protocolo' },
          { key: 'dt_protocolo', label: 'Dt Protocolo' },
          { key: 'cd_irregularidade', label: 'Cod. Irregularidade' },
          { key: 'ds_justificativa', label: 'Justificativa' },
        ],
        label: ['nm_chave', 'nm_cd_apresentante', 'nr_protocolo', 'dt_protocolo', 'cd_irregularidade', 'ds_justificativa'],
        masks: ['', '', '', 'datashora', '', ''],
        filter: false,
        filters: [],
        render: {},
        paginacao: { pag: 'false' }
      },
      dadosPedidoCancelar:{},
      resultadoBusca: ['Ocorrência'],
      loading: true,
      loadingNota: false,
      perPage: 10,
      currentPage: 1,
      dismissSecs: 5,
      dismissCountDownDOC: 0,
      NotaDevolutivaPDF: null,
      sizemodalboleto: 'xl',
      boletoSelecionado: {},
      secondcd: 30,
      numPages: 0,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
        conteudo: "",
      },
      infoModalDeletar: {
        id: "info-modal-deletar",
        title: "",
        conteudo: "",
      },
      // filterFields:[
      //   {key:"nm_devedor",label:"Nome do devedor:",placeholder:"Nome devedor",size:"1", inputType:'',},
      //   {key:"ocorrencia",label:"Ocorrência:",placeholder:"XXXXXXXXX",size:"1", inputType:'',},
      //   {key:"nm_nr_documento_devedor",label:"Documento do devedor:",placeholder:"XXXXXXXXX",size:"1", inputType:'', mask:{cpf:'###.###.###-##', cnpj:'##.###.###/####-##'}},
      //   {key:"numero",label:"Número:",placeholder:"Nº documento",size:"1", inputType:'',},
      //   {key:"nosso_numero",label:"Nosso número:",placeholder:"XXXXXXXXX",size:"1", inputType:'',},
      //   {key:"dt_emissao",label:"Data emissão:",placeholder:"DD/MM/AAAA",size:"1", inputType:'',},
      //   {key:"dt_vencimento",label:"Data vencimento:",placeholder:"DD/MM/AAAA",size:"1", inputType:'',},
      //   {key:"vl_titulo",label:"Valor do título:",placeholder:"R$",size:"1", isCurrency:true, inputType:'',},
      //   {key:"vl_protesto",label:"Valor a protestar:",placeholder:"R$",size:"1", isCurrency:true, inputType:'',},
      // ],
      colunas: [
        { key: "cd_pedido_protesto", label: "Nº Pedido", sortable: false, size: "0.5fr" },
        { key: "nm_nr_titulo", label: "Nº Título", sortable: false, size: "0.75fr" },
        { key: "nm_devedor", label: "Devedor", sortable: false, size: "1.5fr" },
        // { key: "nm_nr_identificacao_devedor",label: "Documento",sortable: true },
        { key: "dt_cadastro", label: "Data de Cadastro", sortable: true, size: "1.15fr", isDate: true },
        { key: "vl_titulo", label: "Valor Título", sortable: true, size: "1fr", isCurrency: true },
        // { key: "vl_custa", label: "Valor Retirada", sortable: true, size: "1fr", isCurrency: true },
        { key: "status_pedido", label: "Status", sortable: true, size: "1fr", isNested: true },
        { key: "ds_ocorrencia_titulo", label: "Ocorrência", sortable: true, size: "1fr" },
        { key: "nr_protocolo", label: "Protocolo", sortable: true, size: "1fr" },
        { key: 'details', label: 'Exibir', sortable: false, size: '0.5fr' },
        {
          key: "actions", label: "Ação", sortable: false, size: "0.5fr", acoes: [
            { icone: 'eye', tamanho: '1x', titulo: 'Visualizar dados do pedido', cor: 'text-primary', condicao: true, funcao: 'visualizarPDF' },
            { icone: 'plus-square', tamanho: '1x', titulo: 'Mais Opções', cor: 'text-primary', condicao: 'maisAcoes', funcao: 'abrirMaisOpcoes' },
            { icone: 'upload', tamanho: '1x', titulo: 'Uploade de Documento', cor: 'text-info', condicao: 'ic_aguardando_anexo', funcao: 'openUploadDocumentosModal' },
            { icone: 'money-bill-wave', tamanho: '1x', titulo: 'Recibo', cor: 'text-success', condicao: 'ic_download_recibo', funcao: 'baixarRecibo' },
            { icone: 'download', tamanho: '1x', titulo: 'Informações sobre a irregularidade', cor: 'text-info', condicao: true, funcao: 'baixarPDF' },
            { icone: 'info-circle', tamanho: '1x', titulo: 'Dados da irregularidade', cor: 'text-danger', condicao: 'hasIrregularidade', funcao: 'detalhesIrregularidade' },
            { icone: 'file-pdf', tamanho: '1x', titulo: 'Download IP', cor: 'text-success', condicao: 'ic_download_ip_SP', funcao: 'downloadIPSP' },
            { icone: 'file-pdf', tamanho: '1x', titulo: 'Download IP', cor: 'text-info', condicao: 'ic_download_ip', funcao: 'downloadIP' },
            { icone: 'dollar-sign', tamanho: '1x', titulo: 'Gerar Pagamento', cor: 'text-primary', condicao: 'ic_gerar_boleto', funcao: 'confirmaBoleto' /*'gerarBoleto_instabilidade'*/},
            { icone: 'dollar-sign', tamanho: '1x', titulo: 'Gerar Pagamento', cor: 'text-success', condicao: 'ic_exibe_boleto', funcao: 'visualizarBoleto' /*'gerarBoleto_instabilidade'*/ },
            { icone: 'file-export', tamanho: '1x', titulo: 'Pagamento Retirada', cor: 'text-warning', condicao: 'ic_pagamento_retirada', funcao: 'abrirPagamentoRetirada' },
            { icone: 'barcode', tamanho: '1x', titulo: 'Download Comprovante', cor: 'text-info', condicao: 'ic_download_comprovante', funcao: 'downloadComprovanteGrid' },
            // { icone: 'trash', tamanho: '1x', titulo: 'Cancelar protesto', cor: 'text-danger', condicao: 'cancela_pedido', funcao: 'cancelaSolicitacaoProtesto' },
          ]
        },
      ],
      colunasMobile: [
        { key: "cd_pedido_protesto", label: "Nº Pedido", sortable: false, size: "0.5fr" },
        { key: "nm_devedor", label: "Devedor", sortable: false, size: "1.5fr" },
        { key: "actions", label: "Exibir", sortable: false, size: "0.5fr" }
      ],
      fields: [
        { key: "cd_pedido_protesto", label: "Nr. Pedido", sortable: false },
        { key: "nm_nr_titulo", label: "Nr. Título", sortable: false },
        { key: "nm_devedor", label: "Devedor", sortable: false },
        // { key: "nm_nr_identificacao_devedor", label: "Documento", sortable: true, },
        { key: "dt_cadastro", label: "Cadastrado em", sortable: true },
        { key: "vl_titulo", label: "Vlr. Título", sortable: true },
        { key: "vl_custa", label: "Vlr p/ Retirada", sortable: true },
        { key: "status_pedido", label: "Status", sortable: true },
        { key: "ds_ocorrencia_titulo", label: "Ocorrência ", sortable: true },
        { key: "nr_protocolo", label: "Protocolo ", sortable: true },
        { key: "actions", label: "Ação" },
        { key: 'Exibir', label: 'Exibir', sortable: false },
      ],
      items: [],
      tutorialAtivo: false,
      CLIENT_KEY_EXPRESS: process.env.VUE_APP_CLIENT_KEY_EXPRESS,
      SELLER_KEY_EXPRESS: process.env.VUE_APP_SELLER_KEY_EXPRESS,
      URL_EXPRESS: process.env.VUE_APP_URL_EXPRESS,
      ENVIRONMENT_EXPRESS: process.env.VUE_APP_ENVIRONMENT_EXPRESS,
      form: {},
      // form: {
      //   nm_devedor: "",
      //   nm_nr_identificacao_devedor: "",
      //   nm_nr_titulo: "",
      //   dt_vencimento: "",
      //   vl_titulo: "R$",
      //   nm_nosso_numero: "",
      //   //cd_pedido_p_status: 1,
      //   ocorrencia: "",
      //   cd_pedido_protesto: '',
      // },
      empresaSelecionada: "",
      statusSelecionado: "",
      empresaCredora: [],
      statusSolicitacao: [],
      listaOcorrencias: [],
      dadosDevedor: [],
      foods: [
        { text: "Aguardando assinatura", value: "1" },
        { text: "Assinados", value: "2" },
      ],
      show: true,
      VempresaCredora: true,
      itemsSelecionados: [],
      erro: false,
      validaCampos: false,
      habilitaga: false,
      validaEmpresaSelecionada: false,
      pdfConfirma: "",
      dadosCartorio: "",
      libCanc: false,
      cd_pedido_protesto_v: "",
      ds_nota_devolutiva_b64: "",
      pdf_boleto: "",
      mensagemBolErro: "",
      msgCotacaoSP: "",
      msgInstrumentoSP: "",
      formasPagamento: [
        {
          text: 'Selecione uma opção de pagamento',
          value: 0
        },
        {
          text: 'BOLETO - Parcela Express ( Tarifa Bancária - R$ 0,87 )',
          value: 2
        },
        {
          text: 'PIX - Parcela Express ( Gratuito )',
          value: 3
        },
        // {
        //   text: 'Cartão de Crédito - Parcela Express ( Tarifa Bancária - 2,89% )',
        //   value: 4
        // }
      ],
      formasPagamentoExpress: [],
      formaPagamento: 0,
      // Pagamento Retirada
      valorRetirada: 0,
      retiradaPedidoNumero: null,
      retiradaMensagemErro: '',
      formasPagamentoRetirada: [
        { text: 'Selecione uma opção de pagamento', value: 0 },
        { text: 'PIX - Parcela Express ( Gratuito )', value: 3 },
        // CC será adicionado dinamicamente via simulação no componente
      ],
    };
  },
  computed: {
    hasAguardandoAnexo: function () {
      return this.itemFiltrado.some(item => item.ic_aguardando_anexo);
    },
    itemFiltrado: function () {
      let relacao = [];
      for (const item of this.items) {
        //if(item.ds_ocorrencia_titulo.)
        let ocorrencia_titulo = item.ds_ocorrencia_titulo_c ? item.ds_ocorrencia_titulo_c : item.ds_ocorrencia_titulo
        let liberaDownloadIP = item.cd_chave_unica != null && ocorrencia_titulo != null && ocorrencia_titulo.substring(0, 1) == '2'
        // validar download do comprovante 
        var download_comprovante = false

        if (item.cd_pedido_cartorio_liquidacao && (item.cd_ted_status == '2' || item.ds_comprovante_ted_pdf_b64 != null)) {
          download_comprovante = true
        }

        const tempoDecorrido = new Date() - new Date(item.dt_cadastro)
        const tempoLimite = 5 * 60 * 1000

        if (item.ds_ocorrencia_titulo != "1 - Pago" && item.ds_ocorrencia_titulo_c != "1 - Pago") {
          relacao.push({
            cd_chave_unica: item.cd_chave_unica,
            cd_pedido_c_status: item.cd_pedido_c_status,
            cd_pedido_cartorio: item.cd_pedido_cartorio,
            cd_pedido_boleto: item.cd_pedido_boleto,
            cd_pedido_cartorio_liquidacao: item.cd_pedido_cartorio_liquidacao,
            cd_pedido_p_status: item.cd_pedido_p_status,
            cd_pedido_protesto: item.cd_pedido_protesto,
            cd_rem_codigo: item.cd_rem_codigo,
            cd_ted_status: item.cd_ted_status,
            ds_endereco_boleto: item.ds_endereco_boleto,
            ds_motivo_irregularidade: item.ds_motivo_irregularidade,
            ds_motivo_irregularidade_c: item.ds_motivo_irregularidade_c,
            ds_ocorrencia_titulo: ocorrencia_titulo,
            dt_cadastro: item.dt_cadastro,
            dt_protocolo: item.dt_protocolo,
            motivo_recusa: item.motivo_recusa,
            nm_devedor: item.nm_devedor,
            nm_nr_identificacao_devedor: item.nm_nr_identificacao_devedor,
            nm_nr_titulo: item.nm_nr_titulo,
            nr_protocolo: item.nr_protocolo,
            status_pedido: item.status_pedido,
            vl_custa: item.vl_custa,
            vl_titulo: item.vl_titulo,
            ic_download_ip: liberaDownloadIP && item.sg_uf_devedor !== 'SP',
            ic_download_ip_SP: item.cd_pedido_protesto != null && item.sg_uf_devedor == 'SP' && liberaDownloadIP,
            nm_nosso_numero: item.nm_nosso_numero,
            dt_emissao: item.dt_emissao,
            nr_cartorio: item.nr_cartorio,
            nm_solicitante: item.nm_solicitante,
            documento_solicitante: item.documento_solicitante,
            endereco_solicitante: item.endereco_solicitante,
            nr_endereco_solicitante: item.nr_endereco_solicitante,
            cep_solicitante: item.cep_solicitante,
            cidade_solicitante: item.cidade_solicitante,
            bairro_solicitante: item.bairro_solicitante,
            complemento_solicitante: item.complemento_solicitante,
            nm_email_solicitante: item.nm_email_solicitante,
            telefone_solicitante: item.telefone_solicitante,
            celular_solicitante: item.celular_solicitante,
            uf_solicitante: item.uf_solicitante,
            nome_cartorio: item.nome_cartorio,
            endereco_cartorio: item.endereco_cartorio,
            nr_endereco_cartorio: item.nr_endereco_cartorio,
            complemento_cartorio: item.complemento_cartorio,
            bairro_cartorio: item.bairro_cartorio,
            cidade_cartorio: item.cidade_cartorio,
            uf_cartorio: item.uf_cartorio,
            cep_cartorio: item.cep_cartorio,
            numero_cartorio: item.numero_cartorio,
            documento_cartorio: item.documento_cartorio,
            telefone_cartorio: item.telefone_cartorio,
            email_cartorio: item.email_cartorio,
            tipoCartorio: item.tipoCartorio,
            nr_cartorio: item.nr_cartorio,
            dt_vencimento: item.dt_vencimento,
            nm_nr_protocolo: item.nm_nr_protocolo,
            nm_nr_titulo: item.nm_nr_titulo,
            decl_portador: item.decl_portador,
            falencia: item.falencia,
            lei9430: item.lei9430,
            especie: item.especie,
            endosso: item.endosso,
            aceite: item.aceite,
            bairro_sacador: item.bairro_sacador,
            cidade_sacador: item.cidade_sacador,
            email_sacador: item.email_sacador,
            endereco_sacador: item.endereco_sacador,
            celular_sacador: item.celular_sacador,
            cep_sacador: item.cep_sacador,
            documento_sacador: item.documento_sacador,
            nm_sacador: item.nm_sacador,
            uf_sacador: item.uf_sacador,
            bairro_cedente: item.bairro_cedente,
            nm_cedente: item.nm_cedente,
            endereco_cedente: item.endereco_cedente,
            cep_cedente: item.cep_cedente,
            documento_cedente: item.documento_cedente,
            uf_cedente: item.uf_cedente,
            bairro_devedor: item.bairro_devedor,
            cidade_devedor: item.cidade_devedor,
            nm_devedor: item.nm_devedor,
            email_devedor: item.email_devedor,
            endereco_devedor: item.endereco_devedor,
            celular_devedor: item.celular_devedor,
            cep_devedor: item.cep_devedor,
            documento_devedor: item.documento_devedor,
            uf_devedor: item.uf_devedor,
            nm_solicitante: item.nm_solicitante,
            nr_endereco_cedente: item.nr_endereco_cedente,
            compl_cedente: item.compl_cedente,
            cidade_cedente: item.cidade_cedente,
            nr_endereco_devedor: item.nr_endereco_devedor,
            compl_devedor: item.compl_devedor,
            ic_gerar_boleto: (item.cd_pedido_cartorio == null || item.cd_pedido_c_status == 6) && item.cd_pedido_p_status == 12 && item.vl_custa > 0.01,
            ic_download_comprovante: download_comprovante,
            ic_exibe_boleto: item.cd_pedido_p_status == 4,
            ic_download_recibo: item.cd_pedido_cartorio != null,
            ic_aguardando_anexo: this.isAguardandoAnexo(item),
            hasIrregularidade: item.hasIrregularidade >= 1,
            sg_prefixo_identificador: item.sg_prefixo_identificador,
            cancela_pedido: tempoDecorrido < tempoLimite && item.cd_pedido_p_status == 1 || item.cd_pedido_p_status == 3 || item.cd_pedido_p_status == 12,
            ic_pagamento_retirada: item.ic_permite_retirada == 1,
          });
        }
        if ((item.ds_ocorrencia_titulo == "1 - Pago" || item.ds_ocorrencia_titulo_c == "1 - Pago") && (item.cd_ted_stats == 2 || item.cd_pedido_boleto_liquidacao == null)) {
          let ds_ocorrencia, ds_ocorrencia_c;
          if (item.cd_pedido_boleto_liquidacao == null) {
            ds_ocorrencia = "";
            ds_ocorrencia_c = "";
          } else {
            ds_ocorrencia = item.ds_ocorrencia_titulo;
            ds_ocorrencia_c = item.ds_ocorrencia_titulo_c;
          }

          relacao.push({
            cd_chave_unica: item.cd_chave_unica,
            cd_pedido_c_status: item.cd_pedido_c_status,
            cd_pedido_cartorio: item.cd_pedido_cartorio,
            cd_pedido_cartorio_liquidacao: item.cd_pedido_cartorio_liquidacao,
            cd_pedido_p_status: item.cd_pedido_p_status,
            cd_pedido_protesto: item.cd_pedido_protesto,
            cd_rem_codigo: item.cd_rem_codigo,
            cd_ted_status: item.cd_ted_status,
            ds_endereco_boleto: item.ds_endereco_boleto,
            ds_motivo_irregularidade: item.ds_motivo_irregularidade,
            ds_motivo_irregularidade_c: item.ds_motivo_irregularidade_c,
            ds_ocorrencia_titulo: ds_ocorrencia,
            ds_ocorrencia_titulo_c: ds_ocorrencia_c,
            dt_cadastro: item.dt_cadastro,
            dt_protocolo: item.dt_protocolo,
            motivo_recusa: item.motivo_recusa,
            nm_devedor: item.nm_devedor,
            nm_nr_identificacao_devedor: item.nm_nr_identificacao_devedor,
            nm_nr_titulo: item.nm_nr_titulo,
            nr_protocolo: item.nr_protocolo,
            status_pedido: item.status_pedido,
            vl_custa: item.vl_custa,
            vl_titulo: item.vl_titulo,
            nm_nosso_numero: item.nm_nosso_numero,
            dt_emissao: item.dt_emissao,
            nr_cartorio: item.nr_cartorio,
            nm_solicitante: item.nm_solicitante,
            documento_solicitante: item.documento_solicitante,
            endereco_solicitante: item.endereco_solicitante,
            nr_endereco_solicitante: item.nr_endereco_solicitante,
            cep_solicitante: item.cep_solicitante,
            cidade_solicitante: item.cidade_solicitante,
            bairro_solicitante: item.bairro_solicitante,
            complemento_solicitante: item.complemento_solicitante,
            nm_email_solicitante: item.nm_email_solicitante,
            telefone_solicitante: item.telefone_solicitante,
            celular_solicitante: item.celular_solicitante,
            uf_solicitante: item.uf_solicitante,
            nome_cartorio: item.nome_cartorio,
            endereco_cartorio: item.endereco_cartorio,
            nr_endereco_cartorio: item.nr_endereco_cartorio,
            complemento_cartorio: item.complemento_cartorio,
            bairro_cartorio: item.bairro_cartorio,
            cidade_cartorio: item.cidade_cartorio,
            uf_cartorio: item.uf_cartorio,
            cep_cartorio: item.cep_cartorio,
            numero_cartorio: item.numero_cartorio,
            documento_cartorio: item.documento_cartorio,
            telefone_cartorio: item.telefone_cartorio,
            email_cartorio: item.email_cartorio,
            tipoCartorio: item.tipoCartorio,
            nr_cartorio: item.nr_cartorio,
            dt_vencimento: item.dt_vencimento,
            nm_nr_protocolo: item.nm_nr_protocolo,
            nm_nr_titulo: item.nm_nr_titulo,
            decl_portador: item.decl_portador,
            falencia: item.falencia,
            lei9430: item.lei9430,
            especie: item.especie,
            endosso: item.endosso,
            aceite: item.aceite,
            bairro_sacador: item.bairro_sacador,
            cidade_sacador: item.cidade_sacador,
            email_sacador: item.email_sacador,
            endereco_sacador: item.endereco_sacador,
            celular_sacador: item.celular_sacador,
            cep_sacador: item.cep_sacador,
            documento_sacador: item.documento_sacador,
            nm_sacador: item.nm_sacador,
            uf_sacador: item.uf_sacador,
            bairro_cedente: item.bairro_cedente,
            nm_cedente: item.nm_cedente,
            endereco_cedente: item.endereco_cedente,
            cep_cedente: item.cep_cedente,
            documento_cedente: item.documento_cedente,
            uf_cedente: item.uf_cedente,
            bairro_devedor: item.bairro_devedor,
            cidade_devedor: item.cidade_devedor,
            nm_devedor: item.nm_devedor,
            email_devedor: item.email_devedor,
            endereco_devedor: item.endereco_devedor,
            celular_devedor: item.celular_devedor,
            cep_devedor: item.cep_devedor,
            documento_devedor: item.documento_devedor,
            uf_devedor: item.uf_devedor,
            nm_solicitante: item.nm_solicitante,
            nr_endereco_cedente: item.nr_endereco_cedente,
            compl_cedente: item.compl_cedente,
            cidade_cedente: item.cidade_cedente,
            nr_endereco_devedor: item.nr_endereco_devedor,
            compl_devedor: item.compl_devedor,
            ic_download_ip: item.cd_chave_unica != null && item.ds_ocorrencia_titulo_c != null && item.sg_uf_devedor !== 'SP',
            ic_download_ip_SP: item.cd_pedido_protesto != null && item.ds_ocorrencia_titulo_c != null && item.sg_uf_devedor == 'SP',
            ic_download_comprovante: download_comprovante,
            ic_exibe_boleto: item.cd_pedido_p_status == 4,
            sg_prefixo_identificador: item.sg_prefixo_identificador,
          });
        }
      }

      // Linha mockada para o tutorial guiado: sempre exibida como PRIMEIRA linha
      // enquanto o tutorial estiver ativo, independente de ter dados reais.
      if (this.tutorialAtivo) {
        relacao.unshift({
          cd_pedido_protesto:        'TUTORIAL',
          nm_nr_titulo:              '00000000001',
          nm_devedor:                'DEVEDOR EXEMPLO DA SILVA',
          nm_nr_identificacao_devedor: '000.000.000-00',
          dt_cadastro:               new Date().toISOString(),
          vl_titulo:                 1500.00,
          vl_custa:                  0,
          status_pedido:             { nm_status: 'Protestado', cor: 'success' },
          ds_ocorrencia_titulo:      '2 - Protestado',
          nr_protocolo:              '000000/2026',
          dt_protocolo:              null,
          nm_nosso_numero:           '00000000001',
          // flags de ação — apenas as relevantes para o tutorial
          ic_pagamento_retirada:     true,
          maisAcoes:                 true,   // força exibição do botão "+" no tutorial
          ic_aguardando_anexo:       false,
          ic_download_recibo:        false,
          ic_gerar_boleto:           false,
          ic_exibe_boleto:           false,
          ic_download_ip:            false,
          ic_download_ip_SP:         false,
          ic_download_comprovante:   false,
          hasIrregularidade:         false,
          cancela_pedido:            false,
          // marca para o template identificar a linha como fictícia
          _is_tutorial_mock:         true,
        });
      }

      return relacao;
    },
    rows() {
      return this.itemFiltrado.length;
    },
  },
  created: function () {
    //this.buscarStatusSolicitacao();
    this.buscarOcorrencias();
    this.pesquisar().then(() => {
      // Pedidos com status 35 - "Aguardando Envio de Documento Anexo"
      if (this.hasAguardandoAnexo) {
        this.$refs['modalAcaoAnexo'].show();
      }
    });

    this.logged = true;
    setTimeout(function(){
      this.loading = false;
    }, 2000);
  },
  mounted() {
    // Inicia o tutorial guiado ao carregar a página (ponto de entrada do fluxo de Retirada)
    var self = this;
    this.$nextTick(function() {
      self.$refs.tutorial.iniciar();
    });
  },
  watch: {
    tutorialAtivo: function(val) {
      if (val && this.$refs.tutorial) {
        // Re-posiciona o spotlight após tutorialAtivo virar true,
        // garantindo que a linha mock já foi injetada no DOM pelo computed itemFiltrado
        this.$nextTick(function() {
          this.$refs.tutorial.posicionarTooltip();
        }.bind(this));
      }
    },
    itemFiltrado: function() {
      // Quando a lista de itens muda (ex: pesquisar() retorna dados reais),
      // re-posiciona o spotlight se o tutorial estiver ativo
      if (this.tutorialAtivo && this.$refs.tutorial) {
        this.$nextTick(function() {
          this.$refs.tutorial.posicionarTooltip();
        }.bind(this));
      }
    },
  },
  filters: {
    moeda: function (value) {
      if (value != null) {
        value = parseFloat(value);
        return value.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        });
      } else {
        return "";
      }
    },
    Moeda: function (v) {
      /*var p = v.indexOf(".");
      v = v.slice(0, (p+3))
      v = v.replace(/\D/g,'');
      v = (v/100).toFixed(2) + '';
      */
      v = v.toString().replace(".", ",");
      v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
      v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
      return 'R$ ' + v;
    },
    dataHora: function (value) {
      if (value !== "" && value !== undefined && value !== null) {
        let date = new Date(value);
        return date.toLocaleDateString("pt-BR", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
      return "";
    },
    data: function (value) {
      if (value !== "" && value !== undefined && value !== null) {
        let date = new Date(value);
        return date.toLocaleDateString("pt-BR", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
      return "";
    },
    documento: function (value) {
      if (value == null) {
        return "";
      } else {
        let v = value;
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g, "");
        if (v.length < 14) {
          //CPF
          //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um hífen entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else {
          //CNPJ
          //Coloca ponto entre o segundo e o terceiro dígitos
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          //Coloca ponto entre o quinto e o sexto dígitos
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          //Coloca uma barra entre o oitavo e o nono dígitos
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          //Coloca um hífen depois do bloco de quatro dígitos
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
        }
        return v;
      }
    },
  },
  methods: {
    isAguardandoAnexo(protesto){
      return protesto.cd_pedido_p_status == 35;  // Pedidos com status 35 - "Aguardando Envio de Documento Anexo"
    },
    montaFormBusca(filtros) {
      return {
        cd_pedido_protesto: (filtros.nrPedido !== null && filtros.nrPedido !== undefined ? filtros.nrPedido : ''),
        nm_devedor: (filtros.nm_devedor !== null && filtros.nm_devedor !== undefined ? filtros.nm_devedor : ''),
        nm_nr_identificacao_devedor: (filtros.nm_nr_identificacao_devedor !== null && filtros.nm_nr_identificacao_devedor !== undefined ? filtros.nm_nr_identificacao_devedor : ''),
        nm_nr_titulo: (filtros.nm_nr_titulo !== null && filtros.nm_nr_titulo !== undefined ? filtros.nm_nr_titulo : ''),
        // dt_vencimento: (filtros.dt_vencimento !== null && filtros.dt_vencimento !== undefined ? filtros.dt_vencimento : ''),
        dt_solicitacao_ini: (filtros.dt_cadastro !== null && filtros.dt_cadastro !== undefined ? filtros.dt_cadastro : ''),
        dt_solicitacao_fim: (filtros.dtVencimento !== null && filtros.dtVencimento !== undefined ? filtros.dtVencimento : ''),
        vl_titulo: (filtros.vl_titulo !== null && filtros.vl_titulo !== undefined ? filtros.vl_titulo : ''),
        vl_saldo: (filtros.vl_saldo !== null && filtros.vl_saldo !== undefined ? filtros.vl_saldo : ''),
        nm_nosso_numero: (filtros.nm_nosso_numero !== null && filtros.nm_nosso_numero !== undefined ? filtros.nm_nosso_numero : ''),
        ocorrencia: (filtros.ocorrencia !== null && filtros.ocorrencia !== undefined ? filtros.ocorrencia : ''),
      };
    },
    detalhesIrregularidade(row) {
      const cd_pedido_protesto = row.cd_pedido_protesto
      const token = localStorage.getItem("jwtToken");
      API.post('/protesto/detalhe_irregularidade', {
        cd_pedido_protesto: cd_pedido_protesto,
        token: token
      })
        .then(response => {
          this.detalhesData = response.data;
          this.$refs.detalhesModal.show();
        })
        .catch(error => {
          console.error('Erro ao obter detalhes:', error);
        });
    },
    downloadArquivo(nm_aws_chave_arquivo, nm_aws_bucket, cd_pedido_protesto) {
      const token = localStorage.getItem("jwtToken");
      API.post('/protesto/download_irregularidade', {
        nm_aws_chave_arquivo: nm_aws_chave_arquivo,
        nm_aws_bucket: nm_aws_bucket,
        token: token
        // Outros parâmetros necessários
      })
        .then((response) => {
          const base64String = response.data; // your base64 string here
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = 'download_irregularidade_' + cd_pedido_protesto + '.pdf'; // the name of the file to download
          link.click();


        })
        .catch((error) => {
          console.error('Erro ao baixar o arquivo:', error);
        });
    },
    filtrarBusca(filtros) {
      this.form = this.montaFormBusca(filtros);
      this.pesquisar();
    },
    exportarBusca(filtros) {
      this.form = this.montaFormBusca(filtros);
      this.exportar();
    },
    onchange: function (event) {
      //console.log(event)
      this.empresaSelecionada = event;
      this.validaCampos = false;
      this.validaEmpresaSelecionada = false;
    },
    selectStatus: function (event) {
      //alert(event)
      this.statusSelecionado = event;
    },
    downloadIP_old(row) {
      // console.log(row)
      let nm_chave = row.cd_chave_unica
      const token = localStorage.getItem("jwtToken");

      API.post("titulos/downloadIP", { token: token, nm_chave: nm_chave }).then(
        (res) => {
          let dlnk = document.getElementById("downloadip");
          dlnk.href = "data:application/pdf;base64," + res.data;
          dlnk.click();
        }
      );
    },
    downloadIP(row){
        let nm_chave = row.cd_chave_unica
        const token = localStorage.getItem("jwtToken");
        API.post("titulos/downloadIP", { token: token, nm_chave: nm_chave }).then(
          (res) => {

            const base64String = res.data; // your base64 string here
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'download_ip_' + row.cd_pedido_protesto + '.pdf'; // the name of the file to download
            link.click();

          }
        );
      
    },
    downloadIPSP: function (row) {
      let cdPedidoProtesto = row.cd_pedido_protesto
      const token = localStorage.getItem("jwtToken");
      this.loading = true;
      API({
        url: "protesto/instrumentoSP",
        method: "post",
        data: { token: token, pedidoProtesto: cdPedidoProtesto },
      })
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            let byteCharacters = atob(res.data),
              byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            let byteArray = new Uint8Array(byteNumbers),
              arquivo = new Blob([byteArray]),
              arquivoURL = window.URL.createObjectURL(arquivo),
              arquivoLink = document.createElement("a"),
              nomeArquivo = `instrumentoProtesto.pdf`;
            arquivoLink.href = arquivoURL;
            arquivoLink.setAttribute("download", nomeArquivo);
            arquivoLink.click();
          } else {
            this.$refs.instrumentoSP.show();
            this.msgInstrumentoSP = res.data.mensagem;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$refs.instrumentoSP.show();
          this.msgInstrumentoSP =
            "Houve uma falha no momento de requisitar o IP junto à CRA-SP, por favor, entre em contato conosco para que possamos averiguar";
          console.log(err);
        });
    },
    exibirCollapse: function () {
      //const res = await API.get(`anuencia/empresascredora?token=${token}`)
      this.VempresaCredora = false;
    },
    numerosLetras: function (event) {
      let val = String(event.target.value);
      val = val.replace(/[^0-9a-zA-Z]/g, "");
      event.target.value = val;
    },
    moeda: function (event) {
      let valor = String(event.target.value);
      valor = valor.replace(/[\D]+/g, "");
      if (valor != "") {
        valor = valor + "";
        valor = valor.replace(/[\D]+/g, "");
        valor = valor + "";
        valor = valor.replace(/([0-9]{2})$/g, ",$1");
        valor = valor.replace(/(\d)(\d{3}),/g, "$1.$2,");
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2"); //Coloca o resto dos pontos
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
      } else {
        valor = "";
      }
      event.target.value = "R$ " + valor;
    },
    async pesquisar() {
      this.validaEmpresaSelecionada = false;
      this.validaCampos = false;

      var self = this;
      self.loading = true;
      const token = localStorage.getItem("jwtToken");

      // self.form.vl_titulo = (self.form.vl_titulo !== undefined ? self.form.vl_titulo.replace("R$", "") : '');
      // self.form.vl_titulo = self.form.vl_titulo.replace(",", ".");
      // self.form.vl_titulo = self.form.vl_titulo.replace(".", "");
      const res = await API.post(`protesto/buscar`, {
        token: token,
        dados: self.form,
      });

      self.items = res.data.dados;
      if (res.data.dados.length == 0) {
        this.dismissCountDownDOC = this.dismissSecs;
        this.habilitaga = false;
      }
      self.loading = false;
    },
    async buscarStatusSolicitacao() {
      var self = this;
      const token = localStorage.getItem("jwtToken");
      const res = await API.post("protesto/listaStatus", { token });
      self.statusSolicitacao = res.data;
      self.statusSolicitacao.push({ value: "0", text: "Status" });
    },
    async buscarOcorrencias() {
      const token = localStorage.getItem("jwtToken");
      API.post("protesto/listaOcorrencias", { token })
        .then((res) => {
          this.listaOcorrencias.push({ value: "", text: "Ocorrências" });
          for (const ocorrencia of res.data.ocorrencias) {
            this.listaOcorrencias.push({
              value: ocorrencia.sg_ocorrencia,
              text: ocorrencia.nm_descricao,
            });
          }
          this.listaOcorrencias.push({ value: "Z", text: "Todos" });
        })
        .catch((err) => console.log(err));
    },
    baixarPDF: function (linha) {
      if (linha.cd_pedido_protesto) {
        const token = localStorage.getItem("jwtToken");
        let self = this,
          id = linha.cd_pedido_protesto
        this.loading = true;
        API.post("protesto/pdfPedidoAnexo", { token, cd_pedido_protesto: id }).then((res) => {
          //console.log(res.data.dados)
          // self.loading = false;
          // let dlnk = document.getElementById("dwnldLnk");
          // dlnk.href = "data:application/pdf;base64," + res.data.dados.ds_complemento_registro;
          // dlnk.click();

          const base64String = res.data.dados.ds_complemento_registro; // your base64 string here
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = 'pedido_protesto_' + id + '.pdf'; // the name of the file to download
          link.click();
          if (res.data.dados.ds_imagem != null) {
            self.baixarAnexoPdf(id, res.data.dados.ds_imagem);
          }
          if (res.data.dados.cd_pedido_cartorio != null) {
            self.baixarReciboPdf(id, res.data.dados.ds_imagem, res.data.dados.cd_pedido_cartorio);
          }
        }).catch(() => {
          this.loading = false;
          alert("Falha ao realizar o Download");
        });
      }
    },
    baixarRecibo(row) {
      var self = this;
      this.loading = true;
      const token = localStorage.getItem("jwtToken");
      self.baixarReciboPdf(row.cd_pedido_protesto, null, row.cd_pedido_cartorio);
      // API.post("protesto/pdfPedidoAnexo", { token, cd_pedido_protesto: row.cd_pedido_protesto })
      //   .then((res) => {
      //     if (res.data.dados.cd_pedido_cartorio != null) {
      //       self.baixarReciboPdf(
      //         row.cd_pedido_protesto,
      //         res.data.dados.ds_imagem,
      //         res.data.dados.cd_pedido_cartorio
      //       );
      //     } else alert("Erro ao gerar recibo");
      //     self.loading = false;
      //   })
      //   .catch(() => {
      //     alert("Falha ao realizar o Download");
      //     this.loading = false;
      //   });
    },
    baixarAnexoPdf(id, anexo) {
      // let dwnldAnexo = document.getElementById("protesto_anexo");
      // dwnldAnexo.href = "data:application/pdf;base64," + anexo;
      // //setTimeout(function(){
      // dwnldAnexo.click();
      // }, 1000);

      const base64String = anexo; // your base64 string here
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'protesto_anexo_' + id + '.pdf'; // the name of the file to download
      link.click();
    },
    baixarNota(id) {
      var self = this;
      this.loading = true;
      const token = localStorage.getItem("jwtToken");
      API.post("protesto/pdfPedidoAnexo", { token, cd_pedido_protesto: id })
        .then((res) => {
          if (res.data.dados.ds_nota_devolutiva_b64 != null) {
            self.baixarNotaPDF(
              id,
              res.data.dados.ds_nota_devolutiva_b64,
            );
          }
          else alert("Erro ao baixar a nota");
          self.loading = false;
        })
        .catch(() => {
          alert("Falha ao realizar o Download");
          this.loading = false;
        });


      // }, 1000);
    },
    baixarNotaPDF(id, anexo) {
      // let dwnldAnexo = document.getElementById("protesto_nota_devolutiva" + id);
      // dwnldAnexo.href = "data:application/pdf;base64," + anexo;
      // //setTimeout(function(){
      // dwnldAnexo.click();
      const base64String = anexo; // your base64 string here
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'protesto_nota_devolutiva_' + id + '.pdf'; // the name of the file to download
      link.click();
    },
    baixarReciboPdf(id, anexo, cd_pedido_cartorio) {
      const token = localStorage.getItem("jwtToken");
      var self = this;
      this.loading = true;
      API.post(
        "/certidao/gerarRecibo",
        { cd_pedido_cartorio: cd_pedido_cartorio, token: token, ic_pedido_protesto: 1 },
        {
          // responseType: 'arraybuffer'
        }
      ).then(
        function (res) {
          if (res.data.situacao) {
            // let dwnldAnexo = document.getElementById("protesto_recibo");
            // dwnldAnexo.href = "data:application/pdf;base64," + res.data.pdf;
            // //setTimeout(function(){
            // dwnldAnexo.click();
            const base64String = res.data.pdf; // your base64 string here
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'download_protesto_recibo_' + id + '.pdf'; // the name of the file to download
            link.click();

          } else alert("Erro ao gerar recibo");
          self.loading = false;
        },
        function (err) {
          this.loading = false;
          alert("Erro ao gerar recibo");
          console.log(err);
        }
      );

      // }, 1000);
    },
    downloadComprovante(cd_pedido_cartorio) {
      const token = localStorage.getItem("jwtToken");
      var self = this;
      this.loading = true;
      API.post(
        "/protesto/comprovanteTed",
        { cd_pedido_cartorio: cd_pedido_cartorio, token: token },
        {
          responseType: "arraybuffer",
        }
      ).then(
        function (res) {
          //console.log(res.data)
          let blob = new Blob([res.data], {
            type: "application/pdf",
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "comprovante.pdf";
          link.click();
          self.loading = false;
        },
        function (err) {
          this.loading = false;
          alert("Erro ao gerar recibo");
          console.log(err);
        }
      );
    },
    visualizarPDF(item) {
      this.loading = true;
      this.$refs["modalLoading"].show();
      this.cd_pedido_protesto_v = item.cd_pedido_protesto;
      const token = localStorage.getItem("jwtToken");
      // console.log(item)
      API.post("protesto/pdfPedidoAnexo", {
        token: token,
        cd_pedido_protesto: item.cd_pedido_protesto,
        cd_pedido_cartorio_liquidacao: item.cd_pedido_cartorio_liquidacao,
        cd_pedido_cartorio: item.cd_pedido_cartorio,
      })
        .then((res) => {
          let loadingTask = pdfx.createLoadingTask(
            "data:application/pdf;base64," +
            res.data.dados.ds_complemento_registro
          );
          this.pdfConfirma = loadingTask;
          loadingTask.promise.then((pdf) => {
            this.numPages = pdf.numPages;
          });
          this.dadosCartorio = res.data.dados;
          this.libCanc = false;
          if (
            res.data.dados.cd_pedido_p_status == 12 ||
            res.data.dados.cd_pedido_p_status == 3
          )
            this.libCanc = true;
          this.loading = false;
          this.$refs["modalLoading"].hide();
          this.$refs["modalConfirmaDados"].show();
        })
        .catch(() => {
          alert("Falha ao exibir detalhes do pedido");
          this.loading = false;
          this.$refs["modalLoading"].hide();
        });

      this.loading = false;
    },
    documento: function (documento) {
      var value = documento;
      if (value == null) {
        return "";
      } else {
        let v = value;
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g, "");
        if (v.length < 14) {
          //CPF
          //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um hífen entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else {
          //CNPJ
          //Coloca ponto entre o segundo e o terceiro dígitos
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          //Coloca ponto entre o quinto e o sexto dígitos
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          //Coloca uma barra entre o oitavo e o nono dígitos
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          //Coloca um hífen depois do bloco de quatro dígitos
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
        }
        return (documento = v);
      }
    },
    cancelarSolicitacao: function () {
      this.$refs["confirmaCancelamento"].show();
    },
    cancelarOperacao() {
      this.$refs["confirmaCancelamento"].hide();
    },

    confirmarCancelamento: function () {
      const token = localStorage.getItem("jwtToken");
      this.$refs["modalLoading"].show();
      API.post(`protesto/cancelarpedido`, {
        token: token,
        cd_pedido_protesto: this.cd_pedido_protesto_v,
      })
        .then((res) => {
          //console.log(res);
          if (res.data.sucesso == 1) {
            this.$refs["modalConfirmaDados"].hide();
            this.$refs["confirmaCancelamento"].hide();
            this.$refs["modalLoading"].hide();
            this.pesquisar();
          } else {
            this.mensagemBolErro = res.data.mensagem;
            this.$refs["modalLoading"].hide();
            this.$refs["modalBoleto"].show();
          }
        })
        .catch((erro) => {
          console.log("post não enviado", erro);
        });
    },
    iniciarContador() {
      this.dtCadastro = new Date(); 

      setInterval(() => {
        this.tempoDecorrido = new Date() - this.dtCadastro;
        this.atualizarExibicaoBotao();
      }, 1000);
    },
    atualizarExibicaoBotao() {
      this.exibirBotao = this.tempoDecorrido < this.tempoLimite;
    },
    cancelarOperacaoProtesto() {
      this.$refs["modalConfirmar"].hide();
    },

    cancelaSolicitacaoProtesto(itemPedido) {
      this.dadosPedidoCancelar = itemPedido;
        this.$refs["modalExpira"].hide()
        this.$refs["modalConfirmar"].show()
     
    },
    pedidoCancelar() {
    let item = this.dadosPedidoCancelar
    const token = localStorage.getItem('jwtToken');
    this.$refs['modalLoading'].show();
    this.$refs["modalConfirmar"].hide();
          API.post('protesto/pedidoCancelar', {
            token: token,
            cd_pedido_protesto: item.cd_pedido_protesto,
            dt_cadastro: item.dt_cadastro
          }).then((res) => {
            if (res.data.sucesso == 1) {
              this.$refs["modalConfirmaDados"].hide();
              this.$refs["modalLoading"].hide();
            } else {
              this.mensagemBolErro = res.data.mensagem;
              this.$refs["modalLoading"].hide();
            }
            this.pesquisar();
          }).catch((erro) => {
            console.log('Não enviado', erro);
          });
      },

    respConfirm(resp) {
      if (resp == "s") this.gerarBoleto(this.cd_pedido_protesto_v);
      if (resp == "n") this.$refs['modalPagamento'].hide();
    },
    confirmaBoleto(dadosTitulo) {
      this.cd_pedido_protesto_v = dadosTitulo.cd_pedido_protesto;
      //console.log(dadosTitulo);
      this.linkPIX = '';
      this.formaPagamento = 0;
      this.$refs['modalPagamento'].show();
      // this.$bvModal.show('modal-conf');
      this.boletoSelecionado = dadosTitulo;
      this.simulacaoPagamentos(dadosTitulo.vl_custa)
      //localStorage.setItem('idPedido');
      //this.bolSel = pedidoid;
    },
    async abrirPagamentoRetirada(dadosTitulo) {
      const token = localStorage.getItem('jwtToken');
      this.loading = true;

      let data = null;

      try {
        const res = await API.post('pedido_retirada/criar', {
          cd_pedido_protesto: dadosTitulo.cd_pedido_protesto,
          nm_chave: dadosTitulo.cd_chave_unica,
        });
        data = res.data;
      } catch (err) {
        // 422 = resposta de negócio (ex: pedido duplicado) — lê o corpo normalmente
        if (err.response && err.response.status === 422 && err.response.data) {
          data = err.response.data;
        } else {
          // Erro real de comunicação / rede
          this.loading = false;
          Swal.fire({
            icon: 'error',
            title: 'Erro de comunicação',
            text: 'Erro ao comunicar com o servidor. Se o problema persistir, entre em contato com o suporte.',
            confirmButtonColor: '#d33',
          });
          console.error(err);
          return;
        }
      }

      this.loading = false;

      const mensagem = data.message || '';
      const temPedido = !!data.cd_pedido_retirada;

      // Sem cd_pedido_retirada: erro real, não tem como continuar
      if (!temPedido) {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao criar pedido',
          text: mensagem || 'Não foi possível criar o pedido de retirada. Tente novamente.',
          confirmButtonColor: '#d33',
        });
        return;
      }

      const vlCusta = parseFloat(data.vl_custa) || 0;
      const prontoParaPagar = vlCusta > 0;

      // Valor de emolumentos disponível — abre pagamento
      if (prontoParaPagar) {
        // Pedido já existia (422 / success: false) — pede confirmação antes de pagar
        if (!data.success) {
          const { isConfirmed } = await Swal.fire({
            icon: 'warning',
            title: 'Atenção',
            html: `${mensagem}<br><br>Deseja prosseguir com o pagamento do pedido <b>Nº ${data.cd_pedido_retirada}</b>?`,
            showCancelButton: true,
            confirmButtonText: 'Sim, pagar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#aaa',
          });
          if (!isConfirmed) return;
        }

        this.retiradaPedidoNumero = data.cd_pedido_retirada;
        this.valorRetirada = vlCusta;
        this.$refs['modalPagamentoRetirada'].abrir({
          ...dadosTitulo,
          cd_pedido_retirada: data.cd_pedido_retirada,
          vl_custa: vlCusta,
        });
      }
      // Sem valor ainda — aguardando cartório informar emolumentos
      else {
        this.retiradaPedidoNumero = data.cd_pedido_retirada;
        const linkRetirada = `<br><br>Você pode acompanhar em <b>Envio de Títulos → <a href="/pedido_retirada" style="color:#3085d6;text-decoration:underline;">Retirada</a></b>.`;
        await Swal.fire({
          icon: data.success ? 'success' : 'info',
          title: data.success ? 'Pedido de Retirada Criado!' : 'Atenção',
          html: (mensagem || 'O cartório responsável irá informar o valor dos emolumentos em breve. Assim que o valor for atualizado, o botão de pagamento ficará disponível.') + linkRetirada,
          confirmButtonText: 'Ok',
          confirmButtonColor: '#3085d6',
          footer: data.success ? '' : `<a href="/pedido_retirada" style="color:#3085d6;">Ver todos os pedidos de retirada →</a>`,
        });
        if (data.success) this.pesquisar();
        else this.$router && this.$router.push('/pedido_retirada').catch(() => {});
      }
    },
    onPagamentoRetiradaRealizado() {
      this.pesquisar();
    },
    downloadComprovanteGrid(item) {
      const token = localStorage.getItem("jwtToken");
      var self = this;
      this.loading = true;
      API.post(
        "/protesto/comprovanteTed",
        { cd_pedido_cartorio: item.cd_pedido_cartorio_liquidacao, token: token },
        {
          responseType: "arraybuffer",
        }
      ).then(
        function (res) {
          //console.log(res.data)
          let blob = new Blob([res.data], {
            type: "application/pdf",
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "comprovante.pdf";
          link.click();
          self.loading = false;
        },
        function (err) {
          this.loading = false;
          alert("Erro ao gerar recibo");
          console.log(err);
        }
      );
    },
    async simulacaoPagamentos(vlr_simulacao) {
      let valor_simulado = parseFloat(vlr_simulacao).toFixed(2).replace('.', '') / 1
      let resSimulacao = await axios.get(`${process.env.VUE_APP_URL_EXPRESS}/v1/simulation/sellers/${process.env.VUE_APP_SELLER_KEY_EXPRESS}?amount_cents=${valor_simulado}`);
      // console.log(resSimulacao.data)
      // resSimulacao = JSON.parse(resSimulacao.data);
      // console.log(resSimulacao.installment_amount_cents)
      let formasPagamentoSimulacao = resSimulacao.data.filter(d => d.type == 'credit')
      let self = this
      this.formasPagamentoExpress = formasPagamentoSimulacao
      formasPagamentoSimulacao.forEach((value) => {
        self.formasPagamento.push({ html: '<b> Cartão de Crédito - Parcela Express  ' + value.installment + ' x ' + this.formataReais(value.installment_amount_cents) + '</b> ( Tarifa Bancária - ' + value.cet + '% )', 'value': value.code })
      })
    },
    async alteraFPG() {
      this.percent_value = null
      // let valor_calculado = this.calcula_valor_pagamento();
      let self = this
      let retornoIP = await axios.get(`https://api.ipify.org/?format=json`)

      const token = localStorage.getItem('jwtToken')
      let costumerBillinAdrres = await API.get(`usuario/logado/endereco?token=${token}`)
      costumerBillinAdrres = costumerBillinAdrres.data

      let description = self.boletoSelecionado.cd_pedido_protesto.toString();



      setTimeout(function () {
        const web_component = document.querySelector('parcela-checkout');
        let dadosFormaPagamento = self.formasPagamentoExpress.filter(d => d.code == self.formaPagamento)[0]
        let amount_cents = parseInt(dadosFormaPagamento.total_amount_cents);

        if (self.formaPagamento.toString().includes("credit") == true) {
          web_component.customerData = {
            amount_cents: amount_cents,
            description: description,
            form_payment: "credit",
            installment_plan: {
              number_installments: dadosFormaPagamento.installment,
            },
            customer: {
              email: localStorage.getItem('usrEmail'),
              ip: retornoIP.data.ip,
              first_name: localStorage.getItem('usrName'),
              last_name: " ",
              document: localStorage.getItem('usrCpf'),
              billing_address: {
                city: costumerBillinAdrres.cidade || 'São Paulo',
                country: costumerBillinAdrres.pais || 'Brasil',
                house_number_or_name: costumerBillinAdrres.numero || '377',
                postal_code: costumerBillinAdrres.cep ? costumerBillinAdrres.cep.replace('-','') : '01009906',
                state: costumerBillinAdrres.estado || 'SP',
                street: costumerBillinAdrres.rua || 'Rua Líbero Badaró',
              },
            },
            extract_identification: 'IEPTB-BR',
            pre_capture: false,
            has_split_rules: false,
            confirmation_required: false,
          };
        }
        web_component.onChange = () => {
          // console.log(state);

        }

        web_component.beforeSubmit = () => self.$refs['modalLoading'].show();

        web_component.onSubmit = (state) => {
          self.$refs['modalLoading'].show();
          if (state.resultCode == 'Authorised') {
            self.atualizaPagamento(state.sale_id);
          }
          else {
            self.$refs['modalLoading'].hide();
            self.$refs['ModalPagamentoCartao'].show();
          }
        };
      }, 10)
    },

    formataReais(number) {
      number = parseFloat((number / 100)).toFixed(2);
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(number);
    },
    apenasNumeros(string) {
      var numsStr = string.replace(/[^0-9]/g, '');
      return parseInt(numsStr);
    },
    startCountDown(duration) {

      let secondsRemaining = duration;
      let sec = 0;
      let self = this

      let countInterval = setInterval(function () {

        sec = parseInt(secondsRemaining % 60);

        self.secondcd = sec;

        secondsRemaining = secondsRemaining - 1;
        if (secondsRemaining < 0) clearInterval(countInterval);

      }, 1000);
    },
    gerarBoleto: function (row) {
      let cd_pedido_boleto = row
      this.mensagemBolErro = "";
      this.loading = true;
      const token = localStorage.getItem("jwtToken");
      API.post(`protesto/gerarpedidoboleto`, {
        cd_pedido_protesto: cd_pedido_boleto,
        formaPagamento: this.formaPagamento,
        token: token,
      })
        .then((res) => {
          if (res.data.situacao == 1) {

            if (this.formaPagamento.toString().includes("credit") == true) {
              API.post(`certidao/exibeBoleto/` + res.data.idBoleto, { token: token }).then((resPdf) => {
                //console.log(resPdf);
                this.pdf = resPdf.data.ds_endereco_boleto;
                this.$refs['modalLoading'].hide();
                this.$refs['modalBoleto'].show();

                //console.log(resPdf.data.urlBoleto);
              }).catch(() => {
                console.log("Boleto não encontrado");
              });
            }
            else if (this.formaPagamento == 2) {
              // console.log('download_boleto_' + this.boletoSelecionado.cd_pedido)
              this.$refs['modalLoading'].hide();
              let dwnldAnexo = document.getElementById('download_boleto');
              dwnldAnexo.href = res.data.ds_endereco_boleto;
              // setTimeout(function(){
              dwnldAnexo.click();
              this.$refs['modalPagamento'].hide();
              // },1);
            }
            else if (this.formaPagamento == 3) {
              // console.log('download_boleto_' + this.boletoSelecionado.cd_pedido)
              this.linkPIX = res.data.ds_endereco_boleto;
              var Quickchart = 'https://quickchart.io/qr?size=300&text=';
              this.pdf_boleto = Quickchart + this.linkPIX;
              // GoogleCharts QR Code - DEPRECATED
              // var GoogleCharts = 'https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=';
              // this.pdf_boleto = GoogleCharts + this.linkPIX;

              this.sizemodalboleto = 'lg'
              this.startCountDown(30);
              let self = this
              let countInterval2 = setInterval(() => {
                self.startCountDown(30);
                self.verificaPagamento(res.data.idBoleto)
              }, 30000)
              this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                if (modalId == 'modalboleto' && bvEvent.type == 'hidden') clearInterval(countInterval2)
              })

              this.$refs['modalLoading'].hide();
              this.$refs['modalPagamento'].hide();
              this.$refs['modalBoleto'].show();
            }
            this.pesquisar();
          }
          else {
            this.mensagemBolErro = res.data.mensagem;
            this.$refs['modalLoading'].hide();
            this.$refs['modalBoleto'].show();
          }

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.mensagemBolErro =
            "Erro ao realizar a solicitação, se o erro persistir contate o suporte";
          this.$refs["modalBoleto"].show();
          console.log(err)
        });
    },
    visualizarBoleto(dadosTitulo) {
      this.boletoSelecionado = dadosTitulo
      // console.log(dadosTitulo)
      let self = this
      this.$refs['modalLoading'].show();
      const token = localStorage.getItem('jwtToken')
      API.post(`certidao/exibeBoleto/` + dadosTitulo.cd_pedido_boleto, { token: token }).then((resPdf) => {
        //console.log(resPdf);
        this.$refs['modalLoading'].hide();
        this.pdf_boleto = resPdf.data.urlBoleto;
        this.$refs['modalBoleto'].show();

        if (dadosTitulo.sg_prefixo_identificador == 'EPP') {
          this.linkPIX = resPdf.data.urlBoleto;
          // GoogleCharts QR Code - DEPRECATED
          // var GoogleCharts = 'https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=';
          // this.pdf_boleto = GoogleCharts + resPdf.data.urlBoleto;
          var Quickchart = 'https://quickchart.io/qr?size=300&text=';
          this.pdf_boleto = Quickchart + encodeURI(this.linkPIX);
          self.sizemodalboleto = 'lg'
          this.verificaPagamento(dadosTitulo.cd_boleto)
          self.startCountDown(30);
          let countInterval2 = setInterval(() => {
            self.startCountDown(30);
            self.verificaPagamento(dadosTitulo.cd_boleto)
          }, 30000)
          this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if (modalId == 'modalboleto' && bvEvent.type == 'hidden') clearInterval(countInterval2)
          })
        }

        if (dadosTitulo.sg_prefixo_identificador == 'EPB') {
          self.sizemodalboleto = 'xl'
          setTimeout(function () {
            let dwnldAnexo = document.getElementById('download_boleto');
            dwnldAnexo.href = resPdf.data.urlBoleto
            //setTimeout(function(){
            dwnldAnexo.click();
            self.$refs['modalBoleto'].hide()
          }, 3000);
        }

        //console.log(resPdf.data.urlBoleto);
      }).catch((e) => {
        console.log("Boleto não encontrado" + e);
      });
      //console.log(cd_cartorio);
    },
    async verificaPagamento(cd_boleto) {
      const token = localStorage.getItem('jwtToken')
      const res = await API.post('certidao/consultapagamento', { token: token, cd_boleto: cd_boleto })
      if (res.data.status == 'succeeded') {
        this.get_certidoes();
        this.$refs['modalBoleto'].hide()
      }
    },
    async cotacaoSP(cd_pedido_protesto) {
      this.loading = true;
      await API.post("protesto/cotacaoSP", {
        token: localStorage.getItem("jwtToken"),
        cd_pedido_protesto: cd_pedido_protesto,
      })
        .then((res) => {
          this.loading = false;
          this.$refs.cotacaoSP.show();
          this.msgCotacaoSP = res.data.status
            ? `Cotação com SP realizada com sucesso.`
            : `Não foi possível realizar a consulta de cotação com SP. \nSe o problema persistir, por favor, tente novamente mais tarde`;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    limparCotacaoSP: function () {
      this.msgCotacaoSP = "";
      this.pesquisar();
    },
    limparInstrumentoSP: function () { },
    anexoNotaDevolutiva: function (cd_pedido_protesto, ds_nota_devolutiva_b64) {
      this.cd_pedido_protesto_v = cd_pedido_protesto;
      this.ds_nota_devolutiva_b64 = ds_nota_devolutiva_b64;

      this.$refs["anexoNotaDevolutiva"].show();
    },
    atualizaArquivo: function (event) {
      this.arquivoNotaDevolutiva = event.target.files[0];
    },
    async atualizaPagamento(salle_id) {
      const token = localStorage.getItem('jwtToken'), res = await API.post('certidao/atualizaPagamentoProtestocc', { token: token, cd_pedido_protesto: this.boletoSelecionado.cd_pedido_protesto, vl_tarifa: this.percent_value, salle_id: salle_id })
      if (res.data.situacao == true) {
        this.$refs['modalLoading'].hide();
        this.$refs['modalPagamento'].hide();
        this.percent_value = null
        this.pesquisar();
      }

    },
    confirmarNotaDevolutiva: async function (cd_pedido_protesto) {
      this.loadingNota = true;

      const fd = new FormData();
      fd.append("file", this.arquivoNotaDevolutiva);
      fd.append("token", localStorage.getItem("jwtToken"));
      fd.append("cd_pedido_protesto", cd_pedido_protesto);

      await API.post("protesto/anexaNota", fd)
        .then((res) => {
          this.loadingNota = false;
          alert("Nota Devolutiva Anexada");
          this.ds_nota_devolutiva_b64 = res.data.arquivo_b64;
        })
        .catch(() => {
          this.loadingNota = false;
          alert("Erro ao anexar Nota Devolutiva Anexada");
        });
    },
    openUploadDocumentosModal(protesto){
      this.cd_pedido_protesto_v = protesto.cd_pedido_protesto;
      this.$bvModal.show('upload-modal');
    },
    async handleFilesSelected({ action, files }) {
      if (action !== 'upload' || !files || !files.length) return;

      this.loading = true

      try {
        // Upload de arquivos em paralelo
        const results = await Promise.all(
            files.map(file => this.uploadDocumento(file))
        )
        this.$bvToast.toast(`${results.length} documento(s) enviado(s) com sucesso`, {
          title: 'Arquivo(s) anexado(s)!',
          variant: 'success',
          toaster: 'b-toaster-bottom-center',
          autoHideDelay: 5000,
          solid: true
        })

      } catch (error) {
        this.$bvToast.toast('Erro ao enviar documentos', {
          title: 'Erro ao anexar arquivo(s)!',
          variant: 'danger',
          toaster: 'b-toaster-bottom-center',
          autoHideDelay: 5000,
          solid: true
        })
      } finally {
        this.loading = false
        this.$bvModal.hide('upload-modal')
      }
    },
    uploadDocumento(file) {
      const formData = new FormData()
      const token = localStorage.getItem("jwtToken");
      formData.append('file', file)
      formData.append("token", token);
      formData.append("cd_pedido_protesto", this.cd_pedido_protesto_v);

      return API.post(`protesto/anexaArquivo`, formData);
    },
    respostaModalInstabilidade(){
      this.$refs['instabilidade'].hide();
    },
    exportar: function () {
      this.loading = true;
      const token = localStorage.getItem("jwtToken");
      this.form.vl_titulo = this.form.vl_titulo
        .replace("R$", "")
        .replace(",", ".")
        .replace(".", "");
      API.post(
        "protesto/excel",
        { token: token, dados: this.form },
        { responseType: "arraybuffer" }
      )
        .then((res) => {
          this.loading = false;

          let url = window.URL.createObjectURL(new Blob([res.data])),
            link = document.createElement("a"),
            arquivo = "protestos_solicitados.xlsx";

          link.href = url;
          link.setAttribute("download", arquivo);
          link.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          this.loading = false;
          this.$refs.msgErroExcel.show();
          console.log(err);
        });
    },
    limparInput: function (nome) {
      if (nome == 'Nome do Devedor') {
        this.form.nm_devedor = ''
      } else if (nome == 'Número do pedido') {
        this.form.cd_pedido_protesto = ''
      } else if (nome == 'Documento do devedor') {
        this.form.nm_nr_identificacao_devedor = ''
      } else if (nome == 'Número do título') {
        this.form.nm_nr_titulo = ''
      } else if (nome == 'Data do Vencimento') {
        this.form.dt_vencimento = ''
      } else if (nome == 'Valor Título') {
        this.form.vl_titulo = ''
      } else if (nome == 'Nosso Número') {
        this.form.nm_nosso_numero = ''
      }
      this.exibePesquisa()
    },
    exibePesquisa: function () {
      this.resultadoBusca = []
      this.resultadoBusca.push('Ocorrência')
      var lista_itens = ['nm_devedor', 'cd_pedido_protesto', 'nm_nr_identificacao_devedor', 'ocorrencia', 'nm_nr_titulo', 'dt_vencimento', 'vl_titulo', 'nm_nosso_numero']
      var lista_itens_label = ['Nome do Devedor', 'Número do pedido', 'Documento do devedor', 'Ocorrência', 'Número do título', 'Data do Vencimento', 'Valor Título', 'Nosso Número']
      for (let item in lista_itens) {
        if (typeof this.form[lista_itens[item]] === 'string' || this.form[lista_itens[item]] instanceof String) {
          if (this.form[lista_itens[item]].trim()) {
            if (this.form[lista_itens[item]].trim() !== "R$") {
              this.resultadoBusca.push(lista_itens_label[item])
            }
          }
        } else if (typeof this.form[lista_itens[item]] === 'number' || this.form[lista_itens[item]] instanceof Number) {
          if (this.form[lista_itens[item]] != '')
            this.resultadoBusca.push(lista_itens_label[item])
        }
      }
      /*william
      form: {
        nm_devedor: "",
        nm_nr_identificacao_devedor: "",
        nm_nr_titulo: "",
        dt_vencimento: "",
        vl_titulo: "R$",
        nm_nosso_numero: "",
        //cd_pedido_p_status: 1,
        ocorrencia: "",
        cd_pedido_protesto: '',
      },
      console.log(event.target.getAttribute("data-name"))
      var componente = event.target.value
      console.log(componente)
      if(componente.trim() === '') {
        event.target.value
      } else {
        this.addnalista(this.resultadoBusca, event.target.getAttribute("data-name"))        
      }
      */
    },
    executarFuncao: function (funcao, linha) {
      if (this[funcao]) {
        this[funcao](linha)
      }
    }
  },
};
</script>

<style scoped>
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}

#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}

#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 80px);
  background-color: #ffffff;
  overflow-x: hidden;
  border-top: 1px solid #f1f1f1;
}

.lista-certidoes {
  color: #000;
}

.lista-certidoes b {
  font-size: 0.85rem;
  color: var(--main-azul);
}

a {
  color: #555;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

#loading-solicitante {
  vertical-align: 0;
  margin-left: -21px;
}

.load {
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spin {
  background: #fff;
  height: 80px;
  width: 80px;
  border-radius: 50vh;
  border-color: #209cee;
  border-top: 5px solid #209cee;
  animation: loading 3s linear infinite;
}

.loading {
  position: absolute;
  color: #000;
  width: 100%;
  text-align: center;
}

@keyframes loading {
  100% {
    transform: rotate(360deg);
  }
}

.bold {
  font-weight: bold;
}

.mensagemErro {
  color: red;
}

#painel>.row {
  justify-content: space-between;
}

#painel {
  scrollbar-width: none;
}

#painel::-webkit-scrollbar {
  display: none;
}

.espaco-menu {
  width: calc(296px + 5px + 5px);
  flex: unset;
  margin-left: calc(3.8vw - 5px);
}

#painel h1 {
  text-align: left;
  font: normal normal bold 25px/41px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597EB5;
  margin-bottom: 33px;
}
#painel .painel-content{
  padding-right: 3.8vw;
}

#painelcontainerfluid {
  padding: 0;
  padding-bottom: 52px;
  margin-top: 37px;
}

@media (max-width:1600px) and (min-width:1400px) {
  .espaco-menu {
    margin-left: calc(20px - 5px) !important;
  }

  #painel .painel-content{
    padding-right: 20px !important;
  }
}

@media (max-width:1399px) and (min-width:1200px) {
  .espaco-menu {
    margin-left: calc(10px - 5px) !important;
    width: fit-content;
    margin-right: 15px;
  }

  #painel .painel-content{
    padding-right: 10px !important;
  }
}

@media (max-width:1199px) {
  #painel {
    padding: 0;
  }

  #painel>.row {
    width: 100%;
    /* max-width: none; */
    margin: 0 !important;
    padding: 0px !important;
    margin-bottom: 70px !important;
    /* margin-left: -17px !important; */
    max-width: 100%;
    margin-left: 0px !important;
  }

  .col-lg-9 {
    max-width: none;
    flex: 1 1 100%;
    padding: 0;
  }

  #painel .painel-content{
    padding: 0px !important;
  }
}

.breadcrumb {
  margin-left: 0px;
  background: unset;
}

.breadcrumb a,
.breadcrumb span,
.breadcrumb-item+.breadcrumb-item::before {
  font: normal normal 200 16px/20px 'Kanit', sans-serif;
}

.breadcrumb-item+.breadcrumb-item::before {
  float: unset;
}

.breadcrumb a {
  color: var(--primary-color);
}

.breadcrumb-item+.breadcrumb-item::before {
  color: var(--primary-color);
}

.breadcrumb span {
  color: var(--secondary-color);
}

.breadcrumb a.disabled {
  text-decoration: none;
  cursor: default;
}

.btn-voltar {
  display: flex;
  align-items: center;
  margin-left: auto;
  letter-spacing: 0px;
  text-decoration: none;
  justify-content: flex-end !important;
  margin-bottom: 20px;
}

.btn-voltar img {
  width: 20px;
  height: 20px;
  margin-left: 6px;
}
</style>
